const POI_SOURCE_PREFIX = /^(overture|atlas)_/

/**
 * Converts database POI type values to the canonical amenities translation key.
 *
 * Providers may prefix otherwise identical types (for example,
 * `overture_doctor`) or return human-readable values such as `Fast Food`.
 */
export const normalizeAmenityPoiTypeKey = (poiType: string): string =>
  poiType
    .trim()
    .toLowerCase()
    .replace(POI_SOURCE_PREFIX, '')
    .replace(/\s+/g, '_')
